import React from "react";
import "./fileCard.css";
import IconButton from "../../../../buttons/IconButton";
import { BsFileEarmarkFill } from "react-icons/bs";
import DeleteButton from "../../../../buttons/DeleteButton";

const FileCard = ({ file_name = "", file_size = "", onDelete, deleteEnabled = true }) => {
  return (
    <div className="card-container">
      <div className="icon-file">
        <BsFileEarmarkFill style={{ color: "#2563eb", fontSize: "24px" }} />
      </div>
      <div className="file-info">
        <h2>{file_name}</h2>
        <p>{file_size} KB</p>
      </div>
      {deleteEnabled && (
        <DeleteButton onClick={onDelete} />
      )}
    </div>
  );
};

export default FileCard;
